import styled from 'styled-components';
import React from 'react';
import Button from 'components/Base/Button/Button';
import { TTacticTask } from '../TacticTable.types';
import { ChevronDown } from '../../../../../../assets/icon/icon';

const StyledExpandButton = styled(Button)<{ $expanded: boolean }>`
  &.ant-btn {
    .expand-icon {
      width: 24px;
      height: 24px;
      transition: transform 0.3s ease;
      transform: ${({ $expanded }) =>
        $expanded ? 'rotate(-180deg)' : 'rotate(0deg)'};
    }
  }
`;

export const ExpandButton = ({
  expanded,
  onExpand,
  record,
  disabled = false,
}: {
  expanded: boolean;
  onExpand: (
    record: TTacticTask,
    e: React.MouseEvent<HTMLElement, MouseEvent>,
  ) => void;
  record: TTacticTask;
  disabled?: boolean;
}) => (
  <StyledExpandButton
    variant="ghost"
    $expanded={expanded}
    onClick={e => {
      e.stopPropagation();
      onExpand(record, e);
    }}
    aria-label={expanded ? 'Collapse row' : 'Expand row'}
    tooltip="Expand"
    disabled={disabled}
  >
    <div className="expand-icon">
      <ChevronDown size={16} />
    </div>
  </StyledExpandButton>
);
